// ERP Sync (#/erp-sync, #/erp-sync/:tab; supervisor, admin). Phase 6 connects the SOC to the ERP over signed webhooks
// (contract §6.7–§6.11). Supervisors watch the feed and press Resync site; admins switch the shadow cutover.
// Tabs: overview (polls every 5 s), cutover, inbox, deliveries, digests.

import type { ErpSyncTab } from '../router.ts';
import { CutoverTab } from './erp-sync/CutoverTab.tsx';
import { DeliveriesTab, DigestsTab, InboxTab } from './erp-sync/LogTabs.tsx';
import { OverviewTab } from './erp-sync/OverviewTab.tsx';

export function ErpSyncScreen({ tab }: { tab: ErpSyncTab }) {
  switch (tab) {
    case 'overview':
      return <OverviewTab />;
    case 'cutover':
      return <CutoverTab />;
    case 'inbox':
      return <InboxTab />;
    case 'deliveries':
      return <DeliveriesTab />;
    case 'digests':
      return <DigestsTab />;
  }
}
